import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gia",
  "use": "gia-usage",
  "viewBox": "0 0 194.8 53.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 194.8 53.9\" id=\"gia\">\n  <path d=\"M93.2,32.4h8.1V42.7a12.25,12.25,0,0,1-4.9.9C86.2,43.6,79,37.4,79,27.2,79,15,88.3,10.3,99.5,10.3a25.78,25.78,0,0,1,12.7,3.4l1.1-11.4C108.2.4,101,0,97.5,0,78.4,0,64.6,7.5,64.6,27.2S80.8,53.9,94.7,53.9a74.62,74.62,0,0,0,20.2-2.4v-29H93.2ZM120.9.9h13.9V53H120.9Zm53.8,0h-17L137.9,53H152l4.1-11.1h19.6L179.6,53h15.2ZM159.3,32,166,11.6h.2L172.4,32ZM25.7,22.2,0,53H15L40.8,22.2ZM18.3,53h15L59.1,22.2H44Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol